import { Modal, Select, Switch, FormControlLabel } from "@mui/material";
import React, { useState } from "react";

import { applyLeave } from "apiHandler/actions";
import { displayDateFormatter } from "components/helpers";
import { useUserData } from "components/customHooks/userDataContext";
import { DesktopDatePicker } from "@mui/x-date-pickers";
import dayjs from "dayjs";

const leaveTypes = ["Vacation (paid)"];

const ApplyLeave = ({ onClose, user }) => {
  const [data, setData] = useState({
    type: "",
    reason: "",
    allDay: true,
    date_from: null,
    date_to: null,
  });
  const [error, setError] = useState("");
  const userData = useUserData();

  const onChange = (e) => {
    setData({ ...data, [e.target.name]: e.target.value });
  };

  const onClick = async () => {
    const payload = {
      user: user ? user.email : userData.email,
      reason: data.reason,
      allDay: data.allDay,
      type: data.type,
      date_from: displayDateFormatter(data.date_from),
      date_to: displayDateFormatter(data.date_to),
    };
    const response = await applyLeave(payload, userData?.access_token);

    if (response) {
      onClose(true);
    } else {
      setError("Failed to apply leave. Please try again.");
    }
  };

  return (
    <Modal open={true} onClose={() => {}}>
      <div className="apply-leave-modal">
        <h1>Apply Leave</h1>
        {user?.firstName && user?.lastName ? (
          <p className="name">
            {user?.firstName} {user?.lastName}
          </p>
        ) : null}

        {error ? <p className="error-msg">{error}</p> : null}
        <div className="first">
          <div className="label">Type</div>
          <Select
            size="small"
            variant="standard"
            native
            name="type"
            value={data.type}
            onChange={onChange}
          >
            <option value=""></option>
            {leaveTypes.map((s) => (
              <option key={s} value={s} className="text-capitalize">
                {s.toLowerCase()}
              </option>
            ))}
          </Select>
          <FormControlLabel
            control={
              <Switch
                checked={data.allDay}
                onChange={(e) => {
                  setData({ ...data, [e.target.name]: e.target.checked });
                }}
                name="allDay"
              />
            }
            label="All Day"
            labelPlacement="start"
          />
        </div>
        <div className="date-cont">
          <div className="label">Starts At</div>
          <DesktopDatePicker
            slotProps={{ textField: { variant: "standard" } }}
            format="MM/DD/YYYY"
            placeholder="MM/DD/YYYY"
            value={dayjs(data.date_from)}
            onChange={(e) =>
              setData({ ...data, date_from: e, date_to: data?.date_to || e })
            }
          />
          <div className="label">Ends At</div>
          <DesktopDatePicker
            slotProps={{ textField: { variant: "standard" } }}
            placeholder="MM/DD/YYYY"
            format="MM/DD/YYYY"
            value={dayjs(data.date_to)}
            onChange={(e) => setData({ ...data, date_to: e })}
          />
        </div>
        <label>Reason</label>
        <textarea
          value={data.reason}
          onChange={(e) => setData({ ...data, reason: e.target.value })}
        />
        <div className="btn-cont">
          <button className="save" onClick={onClick}>
            Apply Leave
          </button>
          <button className="cancel" onClick={onClose}>
            Cancel
          </button>
        </div>
      </div>
    </Modal>
  );
};

export default ApplyLeave;
